import React, { useEffect, useState } from 'react';
import {
  colorBorderGrey,
  colorDisableButton,
  colorLinkGrey,
  colorTextBlack
} from '../../config/theme';
import { Button, Divider, SvgIcon, Tooltip, Typography } from '@mui/material';
import AddNewQuestions from './components/AddNewQuestions';
import AddQuizModal from './components/AddQuizModal';
import ValidationForNewQuizModal from './components/ValidationForNewQuizModal';
import AddQuestionsVideoQuiz from './components/AddQuestionsVideoQuiz';
import { useDispatch } from 'react-redux';
import { deleteQuestions, deleteQuiz } from '../../redux/reducers/contentSlice';
import { useSelector } from 'react-redux';

const AddQuizInVideo = ({
  contentId,
  saveDisabled,
  formikData,
  fileType,
  fileDuration,
  file,
  thumbnailFile
}) => {
  const [isQuizOpen, setIsQuizOpen] = useState(false);
  const [openQuizId, setOpenQuizId] = useState(null);

  const [isEditHover, setIsEditHover] = useState(false);
  const [isDeleteHover, setIsDeleteHover] = useState(false);

  const [isActionModalOpen, setIsActionModalOpen] = useState(false);
  const [openActioModalId, setOpenActionModalId] = useState(null);

  const [isNewQuizModalOpen, setIsNewQuizModalOpen] = useState(false);
  const [isValidationModalOpen, setIsValidationModalOpen] = useState(false);
  const [isNewQuestionModalOpen, setIsNewQuestionModalOpen] = useState(false);
  const [editQuestionData, setEditQuestionData] = useState(null);
  const [questionList, setQuestionList] = useState([]);
  const [quizData, setQuizData] = useState([]);
  const [flashcardId, setFlashcardId] = useState(0);
  const [quizDetails, setQuizDetails] = useState(null);
  const dispatch = useDispatch();

  const { authData } = useSelector(state => state.auth);

  useEffect(() => {
    if (formikData) {
      setQuizData(formikData?.flashCard || []);
    }
  }, [formikData]);

  const handleOpenCloseQuiz = id => {
    if (openQuizId) {
      if (openQuizId == id) {
        setIsQuizOpen(false);
        setOpenQuizId(null);
      } else {
        setIsQuizOpen(true);
        setOpenQuizId(id);
      }
    } else {
      setIsQuizOpen(true);
      setOpenQuizId(id);
    }
  };

  const handleActionModal = id => {
    if (openActioModalId) {
      if (openActioModalId == id) {
        setIsActionModalOpen(false);
        setOpenActionModalId(null);
        setQuizDetails(null);
      } else {
        setIsActionModalOpen(true);
        setOpenActionModalId(id);
      }
    } else {
      setIsActionModalOpen(true);
      setOpenActionModalId(id);
    }
  };

  const handleOpenNewQuestionModal = id => {
    setFlashcardId(id);
    setIsNewQuestionModalOpen(true);
  };

  const handleNewQuiz = () => {
    if (contentId) {
      if (quizData.length < 5) {
        setIsNewQuizModalOpen(true);
      }
    } else {
      setIsValidationModalOpen(true);
    }
  };

  const handleCloseNewQuizModal = () => {
    setQuizDetails(null);
    setIsNewQuizModalOpen(false);
    setIsActionModalOpen(false);
    setOpenActionModalId(null);
    setQuizDetails(null);
  };

  const handleCloseValidationModal = () => {
    setIsValidationModalOpen(false);
  };
  const handleCloseNewQuestionModal = () => {
    setIsNewQuestionModalOpen(false);
    setEditQuestionData(null);
  };

  const handleAddQuestion = newQuestion => {
    let tempQuestionList = [...questionList];

    tempQuestionList.push(newQuestion);
    setQuestionList(tempQuestionList);
  };

  const handleUpdateQuestions = newQuestion => {
    setQuestionList(prevList =>
      prevList.map(question =>
        question.questionId === newQuestion.questionId ? newQuestion : question
      )
    );
  };

  const handleEditQuestion = (data, id) => {
    setFlashcardId(id);
    setEditQuestionData(data);
    setIsNewQuestionModalOpen(true);
  };

  const handleEditQuiz = data => {
    setQuizDetails(data);
    setIsNewQuizModalOpen(true);
  };

  const handleDeleteQuiz = id => {
    let payload = {
      id: id || 0,
      userName: authData?.userName || ''
    };

    dispatch(deleteQuiz(payload));
  };

  const handleDeleteQuestion = id => {
    let payload = {
      id: id || 0,
      userName: authData?.userName || ''
    };

    dispatch(deleteQuestions(payload));
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginTop: '20px',
        width: '416px'
      }}
    >
      <Typography
        style={{
          fontFamily: 'Lato',
          fontWeight: 600,
          fontSize: '16px',
          color: colorLinkGrey,
          lineHeight: '20px',
          marginBottom: '10px'
        }}
      >
        While adding a video, you can also include a quiz within it.
      </Typography>
      <div
        style={{
          display: 'flex'
        }}
      >
        <Tooltip placement="top" title="Add new quiz">
          <Button
            disabled={quizData.length < 5 ? false : true}
            sx={{
              height: 30,
              color: colorTextBlack,
              borderBottom: `1px solid ${quizData.length < 5 ? colorTextBlack : colorBorderGrey}`,
              borderRadius: 0
            }}
            onClick={() => {
              handleNewQuiz();
            }}
            size="small"
          >
            <SvgIcon
              fontSize="small"
              sx={{
                marginRight: 0.6,
                height: '16px',
                width: '16px'
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.49996 2.66669V13.3334M3.16663 8.00002H13.8333"
                  stroke={
                    quizData.length < 5 ? colorTextBlack : colorBorderGrey
                  }
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </SvgIcon>
            Add Quiz
          </Button>
        </Tooltip>
      </div>

      {quizData?.map((item, i) => {
        const flashcardID = item?.flashcardId || 0;
        return (
          <>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '20px',
                alignItems: 'flex-start',
                width: '100%'
              }}
              key={i}
            >
              {/* Main Quiz Div */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%'
                }}
              >
                {/* Quiz Div */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    border: '1px solid #E4E7EB',
                    borderRadius: '8px',
                    padding: '16px',
                    flex: 1
                  }}
                >
                  {/* Title and Arrow */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom:
                        isQuizOpen && openQuizId == item.flashcardId && '15px'
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '16px',
                        fontWeight: 700,
                        lineHeight: '20px',
                        color: colorTextBlack
                      }}
                    >
                      {item.flashcardName || ''}
                    </Typography>
                    <SvgIcon
                      fontSize="small"
                      sx={{
                        height: '20px',
                        width: '20px',
                        cursor: 'pointer'
                      }}
                      onClick={() => handleOpenCloseQuiz(item.flashcardId)}
                    >
                      {isQuizOpen && openQuizId == item.flashcardId ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15 12.5L10 7.5L5 12.5"
                            stroke="#4E565F"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5 7.5L10 12.5L15 7.5"
                            stroke="#4E565F"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </SvgIcon>
                  </div>

                  {/* Quizes */}
                  {isQuizOpen && openQuizId == item.flashcardId && (
                    <>
                      <Divider style={{ color: '#E4E7EB' }} />

                      {/* Questions */}
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          marginTop: '10px',
                          width: '100%'
                        }}
                      >
                        {item?.questions.map((item, i) => {
                          return (
                            <div
                              key={i}
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginBottom: '12px',
                                flex: 1
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: '14px',
                                  fontFamily: 'Lato',
                                  fontWeight: 500,
                                  color: colorTextBlack,

                                  whiteSpace: 'normal',
                                  overflow: 'visible',
                                  textOverflow: 'unset'
                                }}
                              >
                                {item?.questionText}
                              </Typography>

                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between'
                                }}
                              >
                                <SvgIcon
                                  fontSize="small"
                                  sx={{
                                    height: '16px',
                                    width: '16px',
                                    cursor: 'pointer'
                                  }}
                                  onClick={() =>
                                    handleEditQuestion(item, flashcardID)
                                  }
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7.33301 2.66812H4.53301C3.4129 2.66812 2.85285 2.66812 2.42503 2.88611C2.0487 3.07785 1.74274 3.38382 1.55099 3.76014C1.33301 4.18796 1.33301 4.74802 1.33301 5.86812V11.4681C1.33301 12.5882 1.33301 13.1483 1.55099 13.5761C1.74274 13.9524 2.0487 14.2584 2.42503 14.4501C2.85285 14.6681 3.4129 14.6681 4.53301 14.6681H10.133C11.2531 14.6681 11.8132 14.6681 12.241 14.4501C12.6173 14.2584 12.9233 13.9524 13.115 13.5761C13.333 13.1483 13.333 12.5882 13.333 11.4681V8.66812M5.33299 10.6681H6.44935C6.77547 10.6681 6.93853 10.6681 7.09198 10.6313C7.22803 10.5986 7.35809 10.5447 7.47739 10.4716C7.61194 10.3892 7.72724 10.2739 7.95785 10.0433L14.333 3.66812C14.8853 3.11584 14.8853 2.2204 14.333 1.66812C13.7807 1.11584 12.8853 1.11583 12.333 1.66812L5.95783 8.04328C5.72723 8.27388 5.61193 8.38919 5.52947 8.52374C5.45637 8.64304 5.40249 8.7731 5.36983 8.90915C5.33299 9.0626 5.33299 9.22566 5.33299 9.55178V10.6681Z"
                                      stroke="#4E565F"
                                      strokeWidth="1.2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </SvgIcon>
                                <SvgIcon
                                  fontSize="small"
                                  sx={{
                                    height: '16px',
                                    width: '16px',
                                    marginLeft: '15px',
                                    cursor: 'pointer'
                                  }}
                                  onClick={() =>
                                    handleDeleteQuestion(item?.questionId)
                                  }
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M10.6667 3.9987V3.46536C10.6667 2.71863 10.6667 2.34526 10.5213 2.06004C10.3935 1.80916 10.1895 1.60519 9.93865 1.47736C9.65344 1.33203 9.28007 1.33203 8.53333 1.33203H7.46667C6.71993 1.33203 6.34656 1.33203 6.06135 1.47736C5.81046 1.60519 5.60649 1.80916 5.47866 2.06004C5.33333 2.34526 5.33333 2.71863 5.33333 3.46536V3.9987M6.66667 7.66536V10.9987M9.33333 7.66536V10.9987M2 3.9987H14M12.6667 3.9987V11.4654C12.6667 12.5855 12.6667 13.1455 12.4487 13.5733C12.2569 13.9497 11.951 14.2556 11.5746 14.4474C11.1468 14.6654 10.5868 14.6654 9.46667 14.6654H6.53333C5.41323 14.6654 4.85318 14.6654 4.42535 14.4474C4.04903 14.2556 3.74307 13.9497 3.55132 13.5733C3.33333 13.1455 3.33333 12.5855 3.33333 11.4654V3.9987"
                                      stroke="#4E565F"
                                      strokeWidth="1.2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </SvgIcon>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      {/* End */}
                    </>
                  )}
                </div>

                {/* Add New Question tag */}
                {item?.questions.length < 5 && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginTop: '5px'
                    }}
                  >
                    <Tooltip placement="top" title="Add new question">
                      <Button
                        sx={{
                          height: 30,
                          color: colorTextBlack,
                          borderBottom: `1px solid ${colorTextBlack}`,
                          borderRadius: 0
                        }}
                        onClick={() =>
                          handleOpenNewQuestionModal(item.flashcardId)
                        }
                        size="small"
                      >
                        <SvgIcon
                          fontSize="small"
                          sx={{
                            marginRight: 0.6,
                            height: '16px',
                            width: '16px'
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.49996 2.66669V13.3334M3.16663 8.00002H13.8333"
                              stroke={colorTextBlack}
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </SvgIcon>
                        Add new Question
                      </Button>
                    </Tooltip>
                  </div>
                )}
              </div>

              {/* More Action for Quiz */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    border: '1px solid #E4E7EB',
                    borderRadius: '8px',
                    padding: '10px',
                    marginLeft: '10px',
                    cursor: 'pointer'
                    // maxWidth: '50px'
                  }}
                  onClick={() => handleActionModal(item.flashcardId)}
                >
                  <SvgIcon
                    fontSize="small"
                    sx={{
                      height: '32px',
                      width: '32px'
                    }}
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.0003 16.832C16.4606 16.832 16.8337 16.4589 16.8337 15.9987C16.8337 15.5385 16.4606 15.1654 16.0003 15.1654C15.5401 15.1654 15.167 15.5385 15.167 15.9987C15.167 16.4589 15.5401 16.832 16.0003 16.832Z"
                        stroke="#4E565F"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.0003 10.9987C16.4606 10.9987 16.8337 10.6256 16.8337 10.1654C16.8337 9.70513 16.4606 9.33203 16.0003 9.33203C15.5401 9.33203 15.167 9.70513 15.167 10.1654C15.167 10.6256 15.5401 10.9987 16.0003 10.9987Z"
                        stroke="#4E565F"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.0003 22.6654C16.4606 22.6654 16.8337 22.2923 16.8337 21.832C16.8337 21.3718 16.4606 20.9987 16.0003 20.9987C15.5401 20.9987 15.167 21.3718 15.167 21.832C15.167 22.2923 15.5401 22.6654 16.0003 22.6654Z"
                        stroke="#4E565F"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                </div>

                {/* Edit Delete Modal  */}
                {isActionModalOpen && openActioModalId == item.flashcardId && (
                  <>
                    <div
                      style={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        border: '1px solid white',
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        width: '115px',
                        marginLeft: '10px',
                        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.1)',
                        zIndex: 100,
                        marginRight: '-100px',
                        marginBottom: '-200px',
                        marginTop: '1rem'
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%'
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '5px',
                            backgroundColor: isEditHover && colorDisableButton,
                            paddingLeft: '10px',
                            paddingTop: '5px',
                            paddingBottom: '5px',
                            cursor: 'pointer'
                          }}
                          onClick={() => handleEditQuiz(item)}
                          onMouseOver={() => setIsEditHover(true)}
                          onMouseLeave={() => setIsEditHover(false)}
                        >
                          <SvgIcon
                            fontSize="small"
                            sx={{
                              height: '16px',
                              width: '16px',
                              cursor: 'pointer'
                            }}
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.33398 2.66812H4.53398C3.41388 2.66812 2.85383 2.66812 2.426 2.88611C2.04968 3.07785 1.74372 3.38382 1.55197 3.76014C1.33398 4.18796 1.33398 4.74802 1.33398 5.86812V11.4681C1.33398 12.5882 1.33398 13.1483 1.55197 13.5761C1.74372 13.9524 2.04968 14.2584 2.426 14.4501C2.85383 14.6681 3.41388 14.6681 4.53398 14.6681H10.134C11.2541 14.6681 11.8141 14.6681 12.242 14.4501C12.6183 14.2584 12.9242 13.9524 13.116 13.5761C13.334 13.1483 13.334 12.5882 13.334 11.4681V8.66812M5.33397 10.6681H6.45033C6.77645 10.6681 6.93951 10.6681 7.09296 10.6313C7.22901 10.5986 7.35907 10.5447 7.47836 10.4716C7.61292 10.3892 7.72822 10.2739 7.95882 10.0433L14.334 3.66812C14.8863 3.11584 14.8863 2.2204 14.334 1.66812C13.7817 1.11584 12.8863 1.11583 12.334 1.66812L5.95881 8.04328C5.7282 8.27388 5.6129 8.38919 5.53045 8.52374C5.45734 8.64304 5.40347 8.7731 5.37081 8.90915C5.33397 9.0626 5.33397 9.22566 5.33397 9.55178V10.6681Z"
                                stroke="#1F2933"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                          <Typography
                            style={{
                              fontSize: '14px',
                              fontWeight: 600,
                              fontFamily: 'Lato',
                              lineHeight: '18px',
                              color: colorTextBlack,
                              marginLeft: '10px'
                            }}
                          >
                            Edit
                          </Typography>
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            paddingLeft: '10px',
                            paddingTop: '5px',
                            paddingBottom: '5px',
                            backgroundColor:
                              isDeleteHover && colorDisableButton,
                            cursor: 'pointer'
                          }}
                          onClick={() => handleDeleteQuiz(item.flashcardId)}
                          onMouseOver={() => setIsDeleteHover(true)}
                          onMouseLeave={() => setIsDeleteHover(false)}
                        >
                          <SvgIcon
                            fontSize="small"
                            sx={{
                              height: '16px',
                              width: '16px',
                              cursor: 'pointer'
                            }}
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10.6667 3.9987V3.46536C10.6667 2.71863 10.6667 2.34526 10.5213 2.06004C10.3935 1.80916 10.1895 1.60519 9.93865 1.47736C9.65344 1.33203 9.28007 1.33203 8.53333 1.33203H7.46667C6.71993 1.33203 6.34656 1.33203 6.06135 1.47736C5.81046 1.60519 5.60649 1.80916 5.47866 2.06004C5.33333 2.34526 5.33333 2.71863 5.33333 3.46536V3.9987M6.66667 7.66536V10.9987M9.33333 7.66536V10.9987M2 3.9987H14M12.6667 3.9987V11.4654C12.6667 12.5855 12.6667 13.1455 12.4487 13.5733C12.2569 13.9497 11.951 14.2556 11.5746 14.4474C11.1468 14.6654 10.5868 14.6654 9.46667 14.6654H6.53333C5.41323 14.6654 4.85318 14.6654 4.42535 14.4474C4.04903 14.2556 3.74307 13.9497 3.55132 13.5733C3.33333 13.1455 3.33333 12.5855 3.33333 11.4654V3.9987"
                                stroke="#1F2933"
                                strokeWidth="1.4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                          <Typography
                            style={{
                              fontSize: '14px',
                              fontWeight: 600,
                              fontFamily: 'Lato',
                              lineHeight: '18px',
                              color: colorTextBlack,
                              marginLeft: '10px'
                            }}
                          >
                            Delete
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>

              {/* End */}
            </div>
          </>
        );
      })}

      {isNewQuizModalOpen && (
        <AddQuizModal
          open={isNewQuizModalOpen}
          handleClose={handleCloseNewQuizModal}
          contentId={contentId}
          data={quizDetails}
          fileDuration={fileDuration}
        />
      )}

      {isValidationModalOpen && (
        <ValidationForNewQuizModal
          open={isValidationModalOpen}
          handleClose={handleCloseValidationModal}
          saveDisabled={saveDisabled}
          formik={formikData}
          fileType={fileType}
          fileDuration={fileDuration}
          file={file}
          thumbnailFile={thumbnailFile}
        />
      )}

      {isNewQuestionModalOpen && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000
          }}
        >
          <AddQuestionsVideoQuiz
            handleClose={handleCloseNewQuestionModal}
            // handleSubmit={handleAddQuestion}
            // handleUpdate={handleUpdateQuestions}
            data={editQuestionData}
            contentId={contentId}
            flashcardId={flashcardId}
          />
        </div>
      )}
    </div>
  );
};

export default AddQuizInVideo;
